export default "c66d0496eebc8070.png"